<app-page-header title="Start" [translateTitle]="false" icon="home"></app-page-header>
<div class="page-content">

    <div [@fadeInOut]>
        <mat-accordion>
            <mat-expansion-panel expanded="true">
                <mat-expansion-panel-header>Mina rapporter under arbete</mat-expansion-panel-header>
                <br/>
                <app-report-list currentViewId="myongoing" showTitle="false" fixedView="true"></app-report-list>
            </mat-expansion-panel>

            <mat-expansion-panel>
                <mat-expansion-panel-header>Mina verksamheter</mat-expansion-panel-header>
                <br/>
                <app-business-list currentViewId="my" showTitle="false" fixedView="true"></app-business-list>
            </mat-expansion-panel>
        </mat-accordion>
    </div>
</div>
